<h1 mat-dialog-title>Oggi sarebbe il giorno di riposo</h1>
<h2>
  ti vuoi riposare?
</h2>
<div class="btn-group">
  <button (click)="close()">no</button>
  <button cdkFocusInitial (click)="iWantRest()">si voglio riposare</button>
</div>
